<template>
  <div id="app">
    <router-view></router-view>
    <vue-snotify />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  background-color: #f8f9fa;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

::v-deep .snotifyToast__body {
  text-align: left !important;
}
</style>
